import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

const FloatingContact = () => {
  const phoneNumber = '+919709799555'; 
  const whatsappNumber = '+919709799555';

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}`, '_blank');
  };

  return (
    <>
      <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
        {/* Call Button - Blue */}
        <div className="relative group">
          <button
            onClick={handleCall}
            className="bg-blue-500 hover:bg-blue-600 text-white w-10 h-10 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl active:scale-95 animate-float hover:animation-none"
            aria-label="Call us"
          >
            <FaPhoneAlt size={18} />
          </button>
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-800/90 text-white text-xs px-2 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none backdrop-blur-sm">
            Call us
          </span>
        </div>

        {/* WhatsApp Button - Green */}
        <div className="relative group">
          <button
            onClick={handleWhatsApp}
            className="bg-green-600 hover:bg-green-700 text-white w-10 h-10 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl active:scale-95 animate-float hover:animation-none"
            aria-label="WhatsApp us"
          >
            <FaWhatsapp size={20} />
          </button>
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-800/90 text-white text-xs px-2 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none backdrop-blur-sm">
            WhatsApp
          </span>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .group:hover .animate-float {
          animation: none;
        }
      `}</style>
    </>
  );
};

export default FloatingContact;